module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("There once was a man who was fixated on, obsessed you could say, with images of the Virgin Mary. He spent his entire life traveling all over the world—to Rome, to Paris, to Mexico City—to study the paintings and carvings and marble statues of the Madonna. When he died, he went to heaven, and there he asked Saint Peter if he could meet the Blessed Virgin. Saint Peter saw no reason to deny this good man’s request, and so he brought the man to her. “I have just one question,” the man said. “I have studied your face, every rendition of it, for my entire life. Why, in all those countless paintings and carvings and marble statues, do you always look so sad?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well,” said Mary, “to tell you the truth, I really wanted a daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("Is it permitted to utter a mystery?")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THE GOSPEL OF PHILIP")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 66
// module chunks = 0